export var positionAdapter = function positionAdapter(data) {
    return {
        client: data.client,
        broker: data.broker,
        pair: data.pair,
        account: data.account,
        balance: data.balance,
        price: data.price,
        priceUTC: data.priceUTC,
        AVGPrice: data.AVGPrice,
        holdings: data.holdings,
        openPL: data.openPL,
        closedPL: data.closedPL,
        id: data.id
    };
};
